import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Docs16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_323)'>
      <path
        d='M1.73717 0.788504L7.5 2.70945L13.2628 0.788504C13.7405 0.629292 14.25 0.996544 14.25 1.50002V4.00002C14.25 4.41423 13.9142 4.75002 13.5 4.75002C13.0858 4.75002 12.75 4.41423 12.75 4.00002V2.54059L7.73717 4.21153C7.58322 4.26285 7.41678 4.26285 7.26283 4.21153L2.25 2.54059V11.8286L7.75225 13.7937C8.14233 13.933 8.34562 14.3622 8.20631 14.7523C8.06699 15.1424 7.63783 15.3456 7.24775 15.2063L1.24775 13.0635C0.949253 12.9569 0.75 12.6741 0.75 12.3572V1.50002C0.75 0.996544 1.25953 0.629292 1.73717 0.788504Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.75 9.00001C5.75 6.6528 7.65279 4.75001 10 4.75001C12.3472 4.75001 14.25 6.6528 14.25 9.00001C14.25 9.90271 13.9686 10.7397 13.4887 11.428L15.0304 12.9697L13.9697 14.0303L12.428 12.4886C11.7397 12.9686 10.9027 13.25 10 13.25C7.65279 13.25 5.75 11.3472 5.75 9.00001ZM10 6.25001C8.48122 6.25001 7.25 7.48123 7.25 9.00001C7.25 10.5188 8.48122 11.75 10 11.75C11.5188 11.75 12.75 10.5188 12.75 9.00001C12.75 7.48123 11.5188 6.25001 10 6.25001Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_323'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Docs16.displayName = 'Docs16';
export default Docs16;
